import React from "react";
import { Button } from "./ui/button";
import { ArrowUpRight, Sun } from "lucide-react";

const Hero = () => {
  const go = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="top" className="relative pt-32 pb-24 lg:pt-40 lg:pb-40 overflow-hidden">
      {/* Kaitake Ranges watermark background */}
      <div className="absolute inset-0 -z-10">
        <img
          src="/kaitake-ranges.png"
          alt="Kaitake Ranges, New Plymouth"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#F7F6F2]/85 via-[#F7F6F2]/70 to-[#F7F6F2]" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,rgba(245,194,66,0.18),transparent_55%)]" />
      </div>

      <div className="max-w-5xl mx-auto px-6 lg:px-10 relative">
        <div
          data-testid="hero-eyebrow"
          className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/70 backdrop-blur border border-[#D2D7D0] text-xs uppercase tracking-[0.25em] text-[#5C6B61]"
        >
          <Sun className="h-3.5 w-3.5 text-[#F5C242]" />
          Taranaki solar specialists
        </div>

        <h1
          data-testid="hero-headline"
          className="font-display text-5xl sm:text-6xl lg:text-7xl tracking-tighter font-medium mt-8 text-[#1A3626] leading-[1.02] max-w-3xl"
        >
          Power your home with{" "}
          <span className="italic font-light">Taranaki</span>{" "}
          <span className="relative inline-block">
            <span className="relative z-10">sunlight.</span>
            <span className="absolute left-0 right-0 bottom-1 h-3 bg-[#F5C242]/60 -z-0 rounded" />
          </span>
        </h1>

        <p
          data-testid="hero-subhead"
          className="mt-8 text-lg sm:text-xl text-[#5C6B61] max-w-2xl leading-relaxed"
        >
          Central Solar designs, installs and connects premium solar systems
          across New Plymouth and surrounding Taranaki — panels, batteries,
          inverters and grid connections, end-to-end.
        </p>

        <div className="mt-12 flex flex-wrap items-center gap-4">
          <Button
            data-testid="hero-cta-quote"
            onClick={() => go("quote")}
            className="rounded-full bg-[#1A3626] text-white hover:bg-[#234B35] h-14 px-8 text-base group"
          >
            Get a free quote
            <ArrowUpRight className="h-4 w-4 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
          </Button>
          <Button
            data-testid="hero-cta-services"
            onClick={() => go("services")}
            variant="ghost"
            className="rounded-full h-14 px-6 text-base text-[#1A3626] hover:bg-[#E8EAE6]"
          >
            Explore services
          </Button>
        </div>
      </div>
    </section>
  );
};

export default Hero;
